import { FC } from 'react';
import { ViewNoteSection } from './ViewNoteSection';
import { IRecording } from '../../recording/RecordingState';
import { ICaremapNoteResponse } from '../model/NotesClient';
import { ListUlIcon } from '../../theme/Icons';
import { CategorizedActionItems } from '../generic-notes/CategorizedActionItems';
import { INote } from '../generic-notes/INote';

export const ActionItems: FC<{ note: ICaremapNoteResponse | INote; readonly?: boolean }> = ({ note, readonly = false }) => {
    const recording = note.otherAttributes?.recording as IRecording;

    if (!recording?.summary?.actionItems?.length) {
        // No action items - don't show anything (test empty state)
        return null;
    }

    return (
        <ViewNoteSection title="Smart Action Items" Icon={ListUlIcon} showAIIcon>
            <CategorizedActionItems recording={recording} noteId={note.noteId} readonly={readonly} />
        </ViewNoteSection>
    );
};
